import { FC } from 'react'
import { Store } from '@components/icons'
import { useUI } from '@components/ui/context'
import s from './ChecklistButton.module.scss'

const ChecklistButton: FC = () => {
  const { toggleChecklist } = useUI()

  const handleChecklistButton = () => {
    toggleChecklist()
  }

  const calcItemsCount = () => {
    var checkitemarray = []
    var itemlist = localStorage.getItem('checklist')
    if (itemlist) {
      var itemarray = itemlist.split('~')
      for (var i = 0; i < itemarray.length; i++) {
        if (itemarray[i].length > 2) {
          checkitemarray.push(itemarray[i])
        }
      }
    }
    return checkitemarray.length
  }
  var itemsCount = calcItemsCount()

  return (
    <div onClick={handleChecklistButton} className={s['btn-wrap']} title="In-Store Only">
      <div className={s.btn}>
        <div className={s['cart-count-wrapper']}>
          <Store />
          {itemsCount > 0 && (
            <span
              className={`${s['cart-count']} ${
                itemsCount > 99 ? ['cart-count-above-hundred'] : ''
              }`}
            >
              {itemsCount}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default ChecklistButton
